import React from 'react';
import './ForwardedFromQuote.css';

/**
 * KAP-311.1 — attribution block rendered above a forwarded message's content.
 * Reads the denormalized `ForwardRef` snapshot the backend captured at
 * forward-time. Clicking the block deep-links to the source via the existing
 * `?msg=` route handler.
 *
 * Truncates `sourceContent` to 280 chars (matches the contentExcerpt budget
 * used by bookmarks) so a giant forwarded post doesn't dominate the bubble.
 */
const SOURCE_CONTENT_MAX = 280;

function truncate(text) {
  if (typeof text !== 'string' || text.length === 0) return '';
  if (text.length <= SOURCE_CONTENT_MAX) return text;
  return `${text.slice(0, SOURCE_CONTENT_MAX - 1)}…`;
}

function ForwardedFromQuote({ forwardedFrom }) {
  if (!forwardedFrom) return null;
  const senderName = forwardedFrom.sourceSenderDisplayName
    || forwardedFrom.sourceSenderId
    || 'Unknown';
  const excerpt = truncate(forwardedFrom.sourceContent);
  const href = forwardedFrom.sourceConversationId && forwardedFrom.sourceMessageId
    ? `/conversations/${encodeURIComponent(forwardedFrom.sourceConversationId)}?msg=${encodeURIComponent(forwardedFrom.sourceMessageId)}`
    : null;

  const body = (
    <>
      <span className="forwarded-from-label">
        <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 17 20 12 15 7" />
          <path d="M4 18v-2a4 4 0 0 1 4-4h12" />
        </svg>
        <span>Forwarded from <strong>{senderName}</strong></span>
      </span>
      {excerpt && (
        <span className="forwarded-from-excerpt">{excerpt}</span>
      )}
    </>
  );

  if (!href) {
    return <div className="forwarded-from-quote">{body}</div>;
  }
  return (
    <a className="forwarded-from-quote forwarded-from-quote-link" href={href}>
      {body}
    </a>
  );
}

export default ForwardedFromQuote;
